// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--d0mjd","Loading":"Loading--2mCBR","Sub":"Sub--2Pv5J","Extra":"Extra--1IKQf","Checkbox":"Checkbox--3llxA","Margin":"Margin--37-6K","Overdue":"Overdue--1cioW"};